import React, { Component } from 'react';
import { NoNotifications } from '../NoNotifications';
import { Notification } from '../Notification';
import { NotificationWithPush } from '../NotificationWithPush';
import { IHttpApi } from '@cian/http-api';
import { INotificationForDesktopSchema } from '../../repositories/notification-center/entities/notification/NotificationForDesktopSchema';

interface INotificationCenterListProps {
  applicationServerKey: string;
  httpApi?: IHttpApi;
  isWebPushEnabled: boolean;
  notifications: INotificationForDesktopSchema[];
  pushBrowserUrl: string;
  showPushNotification: boolean;
  subdomain: string;

  markAsRead(id: number): void;
  onScroll(): void;
  setShowNotification(showPushNotification: boolean): void;
}

export class NotificationCenterList extends Component<INotificationCenterListProps> {
  public render() {
    const {
      applicationServerKey,
      httpApi,
      isWebPushEnabled,
      markAsRead,
      notifications,
      onScroll,
      pushBrowserUrl,
      setShowNotification,
      showPushNotification,
      subdomain,
    } = this.props;

    return (
      <div
        id="c-notification-center-wrapper"
        className="c-header-modal__notification-wrapper c-header-modal__notification-wrapper--notification-center"
        onScroll={onScroll}
      >
        {isWebPushEnabled && (
          <NotificationWithPush
            applicationServerKey={applicationServerKey}
            pushBrowserUrl={pushBrowserUrl}
            subdomain={subdomain}
            httpApi={httpApi}
            setShowNotification={setShowNotification}
          />
        )}
        {notifications.length > 0 || showPushNotification ? (
          notifications.map(
            ({
              id,
              text,
              title,
              url,
              isRead,
              updateDatetime,
              notificationType,
              updateTimestamp,
              withWebPush,
              payload,
              mediaUrl,
            }) => (
              <Notification
                id={id}
                key={id}
                text={text}
                title={title}
                url={url}
                isRead={isRead}
                updateDatetime={updateDatetime}
                notificationType={notificationType}
                updateTimestamp={updateTimestamp}
                withWebPush={withWebPush}
                payload={payload}
                mediaUrl={mediaUrl}
                markAsRead={markAsRead}
              />
            ),
          )
        ) : (
          <NoNotifications />
        )}
      </div>
    );
  }
}
